import React from 'react';
import { SkeletonRow, SpacingForSkeletonRow } from './subcomponents';
const VerticalCardLoader = ({ className, id = 'verticalCard-loader' }) => (React.createElement("div", { className: className, id: id, "aria-label": "Content Loading" },
    React.createElement(SkeletonRow, { width: "100%" }, "\u200C"),
    React.createElement(SkeletonRow, { width: "60%" }, "\u200C"),
    React.createElement(SpacingForSkeletonRow, { padding: "15px" }),
    React.createElement(SkeletonRow, { width: "100%" }, "\u200C"),
    React.createElement(SkeletonRow, { width: "100%" }, "\u200C"),
    React.createElement(SkeletonRow, { width: "80%" }, "\u200C"),
    React.createElement(SpacingForSkeletonRow, { padding: "15px" }),
    React.createElement(SkeletonRow, { width: "100%" }, "\u200C"),
    React.createElement(SkeletonRow, { width: "100%" }, "\u200C"),
    React.createElement(SkeletonRow, { width: "40%" }, "\u200C"),
    React.createElement(SpacingForSkeletonRow, { padding: "35px" }),
    React.createElement(SkeletonRow, { width: "100%" }, "\u200C")));
export default VerticalCardLoader;
